__webpack_require__.p = "https://frontend-platform-package-reportgrid.ui.moostaging.com/";